// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--1kBi5"};